import { render, staticRenderFns } from "./InctContent.vue?vue&type=template&id=39665e34&scoped=true"
import script from "./InctContent.vue?vue&type=script&lang=js"
export * from "./InctContent.vue?vue&type=script&lang=js"
import style0 from "./InctContent.vue?vue&type=style&index=0&id=39665e34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39665e34",
  null
  
)

export default component.exports